import { DataGrid, type DataGridProps } from '../data-grid/data-grid';

/* To get array of selected row ids, using onRowSelectionModelChange props */
function DataGridWithCheckbox(props: DataGridProps) {
  return (
    <DataGrid
      checkboxSelection // enable checkbox selection
      keepNonExistentRowsSelected // keep selected row when page change
      onCellClick={(cellParams, event, details) => {
        if (cellParams.field === '__check__') return; // prevent trigger onCellClick() when click on checkbox
        props?.onCellClick?.(cellParams, event, details);
      }}
      sx={(theme) => ({
        '.MuiCheckbox-root': {
          width: '24px',
          height: '24px',
          color: theme.palette.grey[400],
        },
        '.Mui-checked': {
          color: theme.palette.primary.main,
        },
      })}
      {...props}
    />
  );
}

export { DataGridWithCheckbox };
export { DataGridProps as DataGridWithCheckboxProps };
